import { css } from "@emotion/css"
import { Card, CardTitle } from "@dashboards/components/Card"

import TopAgencies from "./TopAgencies"
import MediaMix from "./MediaMix"
//
import TopClients from "./TopClients"
import TopSuppliers from "./TopSuppliers"
import { MarketFilter } from "../../filters/MarketFilter"

const styles = {
  grid: css`
    flex: 1;
    margin: var(--spacing-m, 1rem) 0 0 0;
    background-color: var(--light-grey-2, #f5f5f5);
    width: 100%;
    display: grid;
    gap: 1px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
  `,
  cell: css`
    background-color: var(--white, #fff);
    overflow: auto;
  `,
  header: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  `,
}

export default function MarketSummary() {
  return (
    <Card>
      <header className={styles.header}>
        <CardTitle>Market Summary</CardTitle>
        <MarketFilter />
      </header>
      <div className={styles.grid}>
        <div className={styles.cell}>
          <TopAgencies />
        </div>
        <div className={styles.cell}>
          <MediaMix />
        </div>
        <div className={styles.cell}>
          <TopClients />
        </div>
        <div className={styles.cell}>
          <TopSuppliers />
        </div>
      </div>
    </Card>
  )
}
